import { render } from "./FixedButtons.vue?vue&type=template&id=be572e58&scoped=true"
import script from "./FixedButtons.vue?vue&type=script&lang=js"
export * from "./FixedButtons.vue?vue&type=script&lang=js"

import "./FixedButtons.vue?vue&type=style&index=0&id=be572e58&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be572e58"]])

export default __exports__